


























import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import ZonesTable from "@/components/tables/zones-table.vue";
import Vue from "vue";
import Component from "vue-class-component";
import TabsOffice from "@/components/tabs/office.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "zones",
    components: { TabsOffice, Page, PageHeader, ZonesTable },
})
export default class Floors extends Vue {}
